function isPrimitive(target) {
  const type = typeof target;
  return target == null || type != "object" && type != "function";
}
function isObject(target) {
  return target != null && typeof target == "object";
}
function isFunction(target) {
  return typeof target == "function";
}
function isString(target) {
  return typeof target == "string";
}
function isUndefined(target) {
  return typeof target == "undefined";
}
function isPromise(target) {
  return typeof (target == null ? void 0 : target.then) == "function";
}
function mapObject(callback, obj) {
  return Object.keys(obj).reduce((acc, key) => {
    const [k, v] = callback(key, obj[key]);
    acc[k] = v;
    return acc;
  }, {});
}

export { isFunction, isObject, isPrimitive, isPromise, isString, isUndefined, mapObject };
//# sourceMappingURL=shared.esm.js.map
